import { createRoot } from 'react-dom/client';
import useStore from './components/_store'

import Modal from '@/react/libraries/Modal';
import delegate from '@/components/delegate';
import { useEffect, useRef, useState } from 'react';

import CurrentSelectionInfo from './components/_CurrentSelectionInfo';
import QCUserList from './components/_QCUserList';


const Page = ({ payload }) => {
	const { fkDataTable } = payload
	// store
	const currentQCUsers = useStore((state) => state.currentQCUsers)
	const setCurrentQCUsers = useStore((state) => state.setCurrentQCUsers)
	const setTotalRO = useStore((state) => state.setTotalRO)
	const setUnassignedRO = useStore((state) => state.setUnassignedRO)
	const selectedQCUsers = useStore((state) => state.selectedQCUsers)
	const resetSelectedQCUsers = useStore((state) => state.resetSelectedQCUsers)
	const setJurisdictionName = useStore((state) => state.setJurisdictionName)

	// state
	const [modalType, setModalType] = useState('')
	const [modalContent, setModalContent] = useState(null)
	const [country, setCountry] = useState(null)
	const [state, setState] = useState(null)

	// refs
	const modalRef = useRef(null)
	const statusButtonRef = useRef(null)
	const jurisdictionDropdownRef = useRef(null)
	const qcUserListRef = useRef(null)

	const resetStore = () => {
		setCountry(null)
		setState(null)
		setCurrentQCUsers(null)
		setTotalRO(0)
		setUnassignedRO(0)
		setJurisdictionName('Select a jurisdiction')
	}

	const fetchData = async (url) => {
		if (qcUserListRef.current) qcUserListRef.current.setIsLoading(true)

		let res = await axios.get(url, {
			headers: window.HEADER_OBJ
		})

		if (qcUserListRef.current) qcUserListRef.current.setIsLoading(false)

		let data = res.data

		if (!data.status) {
			return
		}

		data = data.data
		setCurrentQCUsers(data.users)
		setTotalRO(data.count)
		setUnassignedRO(data.assigned_count ? data.count - data.assigned_count : data.count)
		setJurisdictionName(data.jurisdiction_name)
	}

	const handleAssign = async (e) => {
		const payload = {
			users: []
		}

		if (country) payload.country_id = country
		if (state) payload.state_id = state

		// compare initial users and selected users
		payload.users = currentQCUsers.map(u => {
			// compare the counts, if there's a difference, add to payload
			let selectedUser = selectedQCUsers.find(su => su.id == u.id)
			if (selectedUser && selectedUser.quantity != u.qc_count) {
				return {
					id: selectedUser.id,
					quantity: selectedUser.quantity
				}
			}
		}).filter(u => u)

		if (payload.users.length == 0) {
			toast.error('Please make some changes.')
			return
		}

		try {
			window.__.loaderButtonInit(e.target)
			const response = await axios.post(`${BASE_URL}admin/qc/assign`, payload, {
				headers: window.HEADER_OBJ
			})

			if (!response.data.status) {
				toast.error(response.data.message)
				return
			}

			toast.success(response.data.message)

			// refresh the table
			if (fkDataTable) {
				fkDataTable.searchDt()
			}
		} catch (error) {
			if (error.response) {
				let data = error.response.data
				toast.error(data.message)
				return
			} else {
				toast.error('Something went wrong. Please try again later.')
				return
			}
		} finally {
			modalRef.current.closeModal()
			e.target.finishLoading()
		}
	}

	const initDropdown = async () => {
		jurisdictionDropdownRef.current = await window.initROCountryMultiLayer('#jurisdictionDropdown')
		document.querySelector('#jurisdictionDropdown').addEventListener('itemSelect', async (e) => {
			resetStore()
			const detail = e.detail
			let param;
			if (detail.key === 'country') {
				setCountry(detail.value)
				param = `country_id=${detail.value}`
			} else if (detail.key === 'state') {
				setState(detail.value)
				param = `state_id=${detail.value}`
			}

			await fetchData(`${BASE_URL}admin/qc/assign-status-data?${param}`)
		})
	}

	const handleModalClose = () => {
		setModalType('')
		resetSelectedQCUsers()
		resetStore()
	}

	useEffect(() => {
		delegate({
			selector: 'button[data-modal]',
			event: 'click',
			handler: async (element, event) => {
				setModalType('assign')
				resetStore()

				modalRef.current.openModal()
				modalRef.current.setIsLoading(true)
				let param = ``

				if (element.dataset.countryId) {
					setCountry(element.dataset.countryId)
					param += `country_id=${element.dataset.countryId}&`
				}

				if (element.dataset.stateId) {
					setState(element.dataset.stateId)
					param += `state_id=${element.dataset.stateId}`
				}

				await fetchData(`${BASE_URL}admin/qc/assign-qc-data?${param}`)
				modalRef.current.setIsLoading(false)
			}
		});
	}, [])

	useEffect(() => {
		if (modalType === 'assign') {
			setModalContent(<h2>Assign Uploads</h2>)
		}

		if (modalType === 'status') {
			setModalContent(<>
				<h2>Assignment Status</h2>
			</>)
		}
	}, [modalType])

	useEffect(() => {
		if (modalType === 'status') {
			initDropdown()
		}
	}, [modalContent])

	return <>
		<button className='btn btn-wide' ref={statusButtonRef} onClick={() => setModalType('status')}>Assignment Status</button>

		<Modal modalTriggerRef={statusButtonRef} ref={modalRef} className='modal__content-wrapper p-2' onClose={handleModalClose}>
			<div className='modal__content-wrapper-header'>
				<div className='flex-grow flex flex-col gap-4'>
					{modalContent}
				</div>

			</div>
			<div className="modal__content-wrapper-body">
				<div className='flex gap-4 items-start'>
					{
						modalType === 'status' &&
						<div id='jurisdictionDropdown' className='w-full' data-multi-select="false"></div>
					}
					<CurrentSelectionInfo className='min-w-[30%] ml-auto' />

				</div>
				<QCUserList ref={qcUserListRef} />
			</div>
			<div className="modal__content-wrapper-footer">
				<button className='btn btn-wide' id='assignButton' onClick={handleAssign}>
					Assign
				</button>
			</div>
		</Modal>
	</>
}



function initPage(selector, payload) {
	createRoot(document.querySelector(selector)).render(
		<Page payload={payload} />
	);
}

export default initPage;